import FormattedMessage from 'I18n/components/FormattedMessage';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler } from './FrequentlyAskedQuestionsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomerPlatformFAQs = ({
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.customerPlatform.whatIsCustomerPlatform.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.customerPlatform.whatIsCustomerPlatform.answer"
      }),
      onExpandedChange: () => handleFaqToggle('customerPlatform.whatIsCustomerPlatform', 'pricing-page-components.frequentlyAskedQuestions.customerPlatform.whatIsCustomerPlatform.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.customerPlatform.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.customerPlatform.whenEligibleForNewPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('customerPlatform.whenEligibleForNewPricing', 'pricing-page-components.frequentlyAskedQuestions.customerPlatform.whenEligibleForNewPricing.question')
    })]
  });
};